export const USER_INFO_CONST = {
    restrictAccess: 'restrictedAccess',
    userAccessStatus: 'userAccessStatus'
}